<div *ngIf="parentView?.mode && dataTypes?.length > 0 && dataKeys?.length > 0" class="data-model-holder">
  {{item.label}}
  <nb-form-field>
    <nb-select [(ngModel)]="selectedType" placeholder="Related Data Type" (selectedChange)="updateRelated()" [fullWidth]="true">
      <nb-option value="self">Self</nb-option>
      <nb-option value="institution">Institution</nb-option>
      <nb-option *ngFor="let key of dataTypes" [value]="key.name">{{key.name}}</nb-option>
    </nb-select>
  </nb-form-field>
  <nb-form-field>
    <input nbInput type="text" [(ngModel)]="selectedKey" (input)="filter()" placeholder="Key" [nbAutocomplete]="auto"  [focusInputOnValueChange]="false" [scrollStrategy]="'reposition'" #newKeyName="ngModel" noWhiteSpace [fullWidth]="true">
    <nb-autocomplete (selectedChange)="updateKey()" #auto>
      <nb-option *ngFor="let key of filteredKeys" [value]="key.name">{{key.friendlyname || key.name}}</nb-option>
    </nb-autocomplete>
    <button nbButton nbSuffix *ngIf="!existing(selectedKey)" (click)="addNewKey()" [disabled]="newKeyName.invalid" aria-label="Create Key" nbTooltip="Create Key"><nb-icon pack="fas" icon="plus"></nb-icon></button>
  </nb-form-field>

  <div class="error-msg" *ngIf="newKeyName.errors && newKeyName.errors.noWhiteSpace">Key name cannot contain white spaces.</div>
</div>
